import { createFileRoute } from "@tanstack/react-router";
import { AgentRunDetail } from "../../features/agents/agentrun-detail";

export const Route = createFileRoute("/_authed/$org/$project/agentruns/$name/$tab")({ component: AgentRunPage });

function AgentRunPage() {
  const { org, project, name, tab } = Route.useParams();
  return <AgentRunDetail scope={{ org, project }} name={name} tab={tab} />;
}
